type ChevronRightIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
  fill?: string;
};

export const ChevronRightIcon = ({ fill = 'currentColor', ...rest }: ChevronRightIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...rest}
  >
    <path
      d="M6.66656 4L5.72656 4.94L8.7799 8L5.72656 11.06L6.66656 12L10.6666 8L6.66656 4Z"
      fill={fill}
    />
  </svg>
);
